import { Reducer } from 'interfaces'
import { CreditCardDataState } from 'components/features/creditCard/creditCardStore/state'
import { CCActivateCardAction } from 'components/features/creditCard/creditCardStore/actions'
import { WsMessageAction } from 'actions/webSocketActions'

const INITIAL_STATE = {
  state: null,
}
export const ccActivationReducer: Reducer<CreditCardDataState['activation']> = (prevState = INITIAL_STATE, action) => {
  switch (action.type) {
    case CCActivateCardAction.type: {
      return {
        ...prevState,
        state: 'pending',
      }
    }

    case WsMessageAction.type: {
      if (action.payload.event !== 'credit_card_activated') {
        return prevState
      }

      return {
        ...prevState,
        state: 'active',
      }
    }
  }
  return prevState
}
